import { api } from "@/lib/api";

// Download a server-generated file (PDF/DOCX) with cookie auth.
export async function downloadServerFile(path, fallbackName) {
  const res = await api.get(path, { responseType: "blob" });
  const disposition = res.headers["content-disposition"] || "";
  const match = disposition.match(/filename="?([^"]+)"?/);
  const filename = match ? match[1] : fallbackName;
  const url = URL.createObjectURL(res.data);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(url);
}

// Turn business assets into files students own: Markdown download.

export function assetsToMarkdown(business, assets) {
  const date = new Date().toLocaleDateString(undefined, { year: "numeric", month: "long", day: "numeric" });
  let md = `# ${business?.name || "My business"}\n\n`;
  if (business?.description) md += `_${business.description}_\n\n`;
  md += `Exported ${date} · Launch to Income\n\n---\n\n`;
  assets.forEach((a) => {
    md += `## ${a.name}\n\n`;
    a.blocks.forEach((b) => {
      const tag = b.provenance && b.provenance !== "student_authored"
        ? ` _(${b.provenance === "ai_assisted_edited" ? "AI assisted · edited" : "AI assisted"})_`
        : "";
      md += `**${b.label}**${tag}\n\n${b.content}\n\n`;
    });
    md += `---\n\n`;
  });
  return md;
}

export function downloadMarkdown(business, assets) {
  const md = assetsToMarkdown(business, assets);
  const blob = new Blob([md], { type: "text/markdown;charset=utf-8" });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = `${(business?.name || "my-business").toLowerCase().replace(/\s+/g, "-")}.md`;
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(url);
}

export function printAssets(business, assets) {
  const date = new Date().toLocaleDateString(undefined, { year: "numeric", month: "long", day: "numeric" });
  const esc = (s) => (s || "").replace(/[&<>]/g, (c) => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;" }[c]));
  const sections = assets.map((a) => `
    <section>
      <h2>${esc(a.name)}</h2>
      ${a.blocks.map((b) => `
        <div class="block">
          <p class="label">${esc(b.label)}${b.provenance && b.provenance !== "student_authored" ? ` <span class="tag">${b.provenance === "ai_assisted_edited" ? "AI assisted · edited" : "AI assisted"}</span>` : ""}</p>
          <p class="content">${esc(b.content).replace(/\n/g, "<br/>")}</p>
        </div>`).join("")}
    </section>`).join("");

  const html = `<!doctype html><html><head><meta charset="utf-8"/>
    <title>${esc(business?.name || "My business")}</title>
    <style>
      @import url('https://fonts.googleapis.com/css2?family=Manrope:wght@500;700&family=DM+Sans&display=swap');
      * { box-sizing: border-box; }
      body { font-family: 'DM Sans', sans-serif; color: #26215C; max-width: 720px; margin: 40px auto; padding: 0 24px; line-height: 1.6; }
      h1 { font-family: 'Manrope', sans-serif; font-size: 28px; margin: 0 0 4px; }
      h2 { font-family: 'Manrope', sans-serif; font-size: 19px; color: #534AB7; margin: 28px 0 10px; }
      .meta { color: #7c7a93; font-size: 13px; margin-bottom: 24px; }
      .desc { font-style: italic; color: #55536b; }
      .block { margin: 0 0 14px; }
      .label { font-size: 12px; text-transform: uppercase; letter-spacing: .08em; color: #9a97b3; font-weight: 700; margin: 0 0 2px; }
      .tag { background:#EEEDFE; color:#3C3489; padding:1px 7px; border-radius:999px; font-size:10px; letter-spacing:0; }
      .content { margin: 0; color: #221f3a; }
      section { border-top: 1px solid #E2E1ED; padding-top: 8px; }
      @media print { body { margin: 0; } }
    </style></head><body>
      <h1>${esc(business?.name || "My business")}</h1>
      ${business?.description ? `<p class="desc">${esc(business.description)}</p>` : ""}
      <p class="meta">Exported ${date} · Launch to Income</p>
      ${sections}
      <script>window.onload = () => { window.print(); }</script>
    </body></html>`;

  const w = window.open("", "_blank");
  if (!w) return false;
  const origin = window.location.origin;
  const withLogo = html.replace(
    `<h1>${esc(business?.name || "My business")}</h1>`,
    `<img src="${origin}/logo.png" alt="Launch to Income" style="height:32px;margin-bottom:14px"/><h1>${esc(business?.name || "My business")}</h1>`
  );
  w.document.write(withLogo);
  w.document.close();
  return true;
}
